import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import SelectSearch from "react-select-search";
import "react-select-search/style.css";
import "./LinkPositionPicker.css";
import { LinkPosition, LinkType } from "../../__generated__/graphql";

interface ILinkPositionPickerProps {
  handleChange: (enumValue: string) => void;
  defaultValue?: string;
  value: string | undefined;
  placeholder?: string;
  controlStyle?: React.CSSProperties;
}

export const LinkPositionPicker = ({
  handleChange,
  defaultValue,
  value,
  placeholder,
  controlStyle,
}: ILinkPositionPickerProps) => {
  const options = Object.keys(LinkPosition).map((item) => ({
    name: item,
    value: item,
  }));
  let capitalized: string = defaultValue ?? "";

  capitalized = capitalized?.[0]?.toUpperCase() + capitalized.slice(1);

  return (
    <FormControl
      fullWidth
      style={{
        display: "flex",
        backgroundColor: "white",
        width: "100%",
        ...controlStyle,
      }}
    >
      <InputLabel id="demo-simple-select-label">Link Position</InputLabel>
      <Select
        variant="outlined"
        labelId="link-position-select"
        id="link-position-select"
        value={capitalized}
        label="Link position"
        defaultValue={capitalized}
        onChange={(event) => handleChange(event.target.value.toLowerCase())}
      >
        {options?.map((item) => {
          return <MenuItem value={item.name}>{item.value}</MenuItem>;
        })}
      </Select>
    </FormControl>
  );
};
